/**
 * Main menu component.
 * Displays the application's main navigation menu with collapsible content,
 * login section for anonymous users, and top bar. Handles menu visibility based on
 * current page and focus state, with animation transitions.
 */
import Container from '@components/atoms/container/menuContainer';
import Content from '@components/elements/menu/menuContent';
import Context from '@shared/components/utils/context/menuContext';
import Login from '@components/elements/menu/menuLogin';
import Mask from '@components/atoms/mask/menuMask';
import Search from '@components/elements/menu/menuSearch';
import useMenu from './useMenu';

/**
 * Main menu component that manages menu visibility and animations.
 * Displays menu content, login section, and handles focus-based animations.
 *
 * @returns {JSX.Element | null} Menu component or null if not initialized
 */
export default function Menu() {
  const { context, display, props } = useMenu();
  return display ? (
    <Context.Provider value={context}>
      <Mask {...props.mask} />
      <Container {...props.container}>
        <Login />
        <Search />
        <Content />
      </Container>
    </Context.Provider>
  ) : null;
}
